import { useCallback } from 'react'
import { useActivitiesContext } from '../../../../context'
import { closeDetailsActionCreator } from '../../../../state'

export function useHandlers() {
  const [, dispatch] = useActivitiesContext()
  const handleBackClick = useCallback(() => {
    dispatch(closeDetailsActionCreator())
  }, [dispatch])

  return {
    handleBackClick,
  }
}
